export const STR = {
  fr: {
    wa: {
      defaultMsg: "Bonjour François, je souhaite prendre contact avec Porte de Lumière. Merci !",
      servicesMsg: "Bonjour François, je souhaite des informations sur vos accompagnements. Merci !",
    },
    marquee: ["Analyse informationnelle", "Harmonisation énergétique", "Psychogénéalogie", "Vies passées", "Nettoyage énergétique holistique", "Écoute & confidentialité", "Accompagnement personnalisé"],
    nav: { home: "Accueil", offers: "Accompagnements", contact: "Contact", whatsapp: "WhatsApp", openMenu: "Ouvrir le menu", closeMenu: "Fermer le menu", logoAria: "Porte de Lumière — Accueil", waFloat: "Contacter Porte de Lumière sur WhatsApp" },
    footer: {
      tagline: "Un espace pour explorer, comprendre et avancer vers davantage d'harmonie intérieure.",
      signature: "Analyse informationnelle et nettoyage énergétique holistique",
      navTitle: "Navigation", contactTitle: "Contact",
      links: { home: "Accueil", offers: "Mes accompagnements", contact: "Contact" },
      whatsapp: "WhatsApp", phone: "Téléphone", facebook: "Facebook — Porte de Lumière", tiktok: "TikTok — Porte de Lumière",
      rights: "Tous droits réservés.",
    },
    hero: {
      eyebrow: "Thérapies quantiques holistiques & énergétiques",
      titleA: "Porte", titleB: "de Lumière",
      paragraph: "François Gautier MAKARGA — praticien certifié Spirivie. Un espace d'écoute, d'exploration et d'accompagnement holistique pour explorer votre vécu, vos schémas personnels et familiaux, et avancer vers davantage d'harmonie intérieure.",
      ctaWhatsapp: "WhatsApp direct", ctaOffers: "Découvrir les accompagnements",
      imgAlt: "Une porte de lumière dans un ciel bleu aux nuages lumineux",
    },
    about: {
      eyebrow: "Qui suis-je ?",
      titleA: "François Gautier", titleB: "MAKARGA",
      p1: "Praticien certifié Spirivie en thérapie énergétique et en psychogénéalogie. À travers Porte de Lumière, je propose un espace d'écoute, d'exploration et d'accompagnement holistique destiné aux personnes qui souhaitent mieux comprendre leur vécu, explorer leurs schémas personnels et familiaux et avancer vers davantage d'harmonie intérieure.",
      p2: "Ma démarche s'inscrit dans une approche globale de la personne : chaque accompagnement est personnalisé, dans un cadre d'écoute, de respect et de confidentialité.",
      quote: "Porte de Lumière : un espace pour explorer, comprendre et avancer.",
      certTitle: "Praticien certifié Spirivie",
      certSub: "Thérapie énergétique & psychogénéalogie",
      badgeAlt: "Badge Spirivie — Praticien certifié",
    },
    dimensions: {
      eyebrow: "La démarche",
      titleA: "Une approche", titleB: "globale", titleC: "de la personne",
      items: [
        { title: "Dimension émotionnelle", text: "Écouter, mettre en mots et apaiser ce qui se vit en vous, dans un cadre de respect et de confidentialité." },
        { title: "Dimension énergétique", text: "Explorer et rééquilibrer les informations et schémas qui traversent votre vécu, selon l'approche informationnelle." },
        { title: "Dimension transgénérationnelle", text: "Remonter le fil de votre histoire familiale pour comprendre les schémas qui se transmettent." },
        { title: "Dimension spirituelle", text: "Ouvrir un espace d'exploration intérieure — y compris la thématique des vies passées — selon vos objectifs." },
      ],
    },
    offersTeaser: { eyebrow: "Mes accompagnements", titleA: "Explorer, comprendre,", titleB: "avancer", cta: "Voir le détail" },
    offers: [
      {
        id: "analyse-informationnelle", tagline: "Une séance d'exploration", title: "Analyse informationnelle",
        price: "19 000 FCFA", priceAlt: "≈ 29 € / 32 $",
        description: "Une séance d'exploration permettant d'identifier et d'examiner les informations et les schémas que vous souhaitez travailler dans le cadre de votre démarche personnelle.",
        points: ["Identifier les informations et schémas personnels", "Examiner ce que vous souhaitez travailler", "Séance d'exploration personnalisée"],
        duration: null,
      },
      {
        id: "harmonisation-informationnelle", tagline: "Un accompagnement individuel", title: "Harmonisation informationnelle",
        price: "39 000 FCFA", priceAlt: "≈ 59 € / 65 $",
        description: "Un accompagnement individuel orienté vers une démarche d'harmonisation et de rééquilibrage selon l'approche informationnelle proposée par Porte de Lumière.",
        points: ["Harmonisation et rééquilibrage", "Approche informationnelle de Porte de Lumière", "Accompagnement individuel dédié"],
        duration: null,
      },
      {
        id: "programme-transgenerationnel-3-mois", tagline: "Programme de 3 mois", title: "Accompagnement holistique transgénérationnel & vies passées",
        price: "150 000 FCFA", priceAlt: "≈ 229 € / 248 $",
        description: "Un accompagnement personnalisé sur trois mois pour explorer votre histoire familiale, vos schémas transgénérationnels et, dans le cadre de votre démarche spirituelle, la thématique des vies passées. Le parcours est construit progressivement, selon votre situation et vos objectifs.",
        points: ["Exploration de votre histoire familiale", "Schémas transgénérationnels", "Thématique des vies passées (démarche spirituelle)", "Parcours progressif selon vos objectifs"],
        duration: "Durée : 3 mois",
      },
      {
        id: "programme-transgenerationnel-6-mois", tagline: "Programme de 6 mois", title: "Accompagnement holistique transgénérationnel & vies passées",
        price: "250 000 FCFA", priceAlt: "≈ 381 € / 412 $",
        description: "Un accompagnement personnalisé sur six mois pour approfondir l'exploration de votre histoire familiale, de vos schémas transgénérationnels et de la thématique des vies passées. Un parcours complet, construit progressivement selon votre situation, vos questionnements et vos objectifs.",
        points: ["Exploration approfondie de votre histoire familiale", "Schémas transgénérationnels", "Thématique des vies passées (démarche spirituelle)", "Parcours progressif selon votre situation, vos questionnements et vos objectifs"],
        duration: "Durée : 6 mois",
      },
    ],
    testimonials: {
      eyebrow: "Témoignages", titleA: "Ils ont cheminé vers", titleB: "plus de lumière",
      items: [
        { author: "A. M.", quote: "J'ai enfin compris d'où venaient certains schémas qui se répétaient dans ma famille. Merci pour cette écoute et cette douceur." },
        { author: "S. K.", quote: "Un accompagnement bienveillant, dans un cadre de confiance et de confidentialité. Je me sens plus légère, plus alignée." },
        { author: "J. D.", quote: "Le programme de six mois m'a permis d'explorer mon histoire familiale en profondeur, à mon rythme. Une vraie rencontre avec moi-même." },
      ],
    },
    sound: {
      eyebrow: "L'expérience", titleA: "Une musique de", titleB: "méditation douce",
      text: "Pendant votre visite, une musique de méditation douce — nappe chaleureuse et bols chantants aux fréquences apaisantes — peut accompagner votre parcours. Activez-la en toute simplicité depuis la bulle en bas à gauche.",
      audioOn: "Méditation douce active", audioOff: "Méditation douce", audioTitle: "Musique de méditation douce",
    },
    final: {
      eyebrow: "Commencer",
      title: "Vous souhaitez poser une question ou prendre contact pour un accompagnement ?",
      ctaContact: "Formulaire de contact",
    },
    acc: {
      eyebrow: "Mes accompagnements", titleA: "Des chemins vers", titleB: "plus d'harmonie",
      paragraph: "Analyse informationnelle, harmonisation énergétique et accompagnement holistique transgénérationnel — chaque parcours est personnalisé, dans un cadre d'écoute, de respect et de confidentialité.",
      disclaimerTitle: "Important",
      disclaimer: "Les accompagnements proposés par Porte de Lumière relèvent d'une démarche de bien-être, de développement personnel et d'exploration spirituelle. Ils ne remplacent pas un diagnostic, un traitement ou un suivi médical ou psychologique lorsque celui-ci est nécessaire.",
      ctaTitle: "Prêt à faire le premier pas ?",
      ctaText: "Contactez-moi directement par téléphone ou WhatsApp pour toute demande d'information ou prise de rendez-vous.",
      whatsapp: "WhatsApp direct", contact: "Contact", book: "Réserver un créneau",
    },
    contact: {
      eyebrow: "Contactez Porte de Lumière", titleA: "Poser une question,", titleB: "prendre contact",
      intro: "Vous souhaitez poser une question ou prendre contact pour un accompagnement ? Écrivez-moi via le formulaire ou contactez-moi directement par téléphone ou WhatsApp.",
      bookCta: "Réserver un créneau en ligne",
      form: {
        name: "Votre nom *", namePh: "Votre nom complet",
        email: "Votre email *", emailPh: "vous@exemple.com",
        phone: "Téléphone / WhatsApp", phonePh: "+237 6 .. .. .. ..",
        service: "Accompagnement", servicePh: "Choisir (optionnel)",
        message: "Votre message *", messagePh: "Partagez votre question ou ce que vous souhaitez explorer…",
        submit: "Envoyer le message", sending: "Envoi en cours…",
        note: "Votre message parvient directement à François par email. Pour une réponse immédiate, privilégiez WhatsApp.",
        successTitle: "Message envoyé",
        successText: "Merci pour votre message. François Gautier MAKARGA vous répondra dans les meilleurs délais.",
        successReset: "Envoyer un autre message",
      },
      channels: { email: "Email", whatsapp: "WhatsApp direct", phone: "Téléphone", facebook: "Facebook", tiktok: "TikTok" },
      quote: "Analyse informationnelle et nettoyage énergétique holistique.",
    },
    booking: {
      eyebrow: "Réservation", title: "Réserver un créneau",
      intro: "Choisissez l'accompagnement, la date et l'heure : votre demande parvient directement à François par email, qui vous confirme le créneau.",
      serviceLabel: "Accompagnement *", servicePh: "Choisir un accompagnement", unknown: "Je ne sais pas encore",
      dateLabel: "Date", slotLabel: "Créneau",
      nameLabel: "Votre nom *", namePh: "Votre nom complet",
      emailLabel: "Votre email *", emailPh: "vous@exemple.com",
      phoneLabel: "Téléphone / WhatsApp", phonePh: "+237 6 .. .. .. ..",
      submit: "Envoyer la demande de réservation", sending: "Envoi en cours…",
      note: "Sans engagement — François vous confirme le créneau par WhatsApp ou email selon ses disponibilités.",
      successTitle: "Demande envoyée",
      successText: (service, date, slot) => `${service} — ${date}, créneau ${slot}. François Gautier MAKARGA confirmera ce créneau avec vous dans les meilleurs délais, sous réserve de disponibilité.`,
      close: "Fermer", ariaClose: "Fermer",
      onError: "Choisissez d'abord une date et un créneau.",
    },
    toasts: {
      contactOk: "Message envoyé — vous recevrez une confirmation par email.",
      contactOkNoEmail: "Message bien reçu ! François vous répondra très vite.",
      contactErr: "Impossible d'envoyer le message. Réessayez ou contactez-moi par WhatsApp.",
      bookingOk: "Demande de réservation envoyée — vous recevrez un email de confirmation.",
      bookingOkNoEmail: "Demande enregistrée ! François vous confirmera le créneau.",
      bookingErr: "Impossible d'envoyer la réservation. Réessayez ou passez par WhatsApp.",
    },
  },
  en: {
    wa: {
      defaultMsg: "Hello François, I would like to get in touch with Porte de Lumière. Thank you!",
      servicesMsg: "Hello François, I would like information about your programs. Thank you!",
    },
    marquee: ["Informational analysis", "Energy harmonisation", "Psychogenealogy", "Past lives", "Holistic energy cleansing", "Listening & confidentiality", "Tailored support"],
    nav: { home: "Home", offers: "Programs", contact: "Contact", whatsapp: "WhatsApp", openMenu: "Open menu", closeMenu: "Close menu", logoAria: "Porte de Lumière — Home", waFloat: "Contact Porte de Lumière on WhatsApp" },
    footer: {
      tagline: "A space to explore, understand and move forward towards greater inner harmony.",
      signature: "Informational analysis and holistic energy cleansing",
      navTitle: "Navigation", contactTitle: "Contact",
      links: { home: "Home", offers: "My programs", contact: "Contact" },
      whatsapp: "WhatsApp", phone: "Phone", facebook: "Facebook — Porte de Lumière", tiktok: "TikTok — Porte de Lumière",
      rights: "All rights reserved.",
    },
    hero: {
      eyebrow: "Holistic quantum & energy therapies",
      titleA: "Porte", titleB: "de Lumière",
      paragraph: "François Gautier MAKARGA — Spirivie certified practitioner. A space for listening, exploration and holistic support to explore your life experience, your personal and family patterns, and move towards greater inner harmony.",
      ctaWhatsapp: "WhatsApp direct", ctaOffers: "Explore the programs",
      imgAlt: "A doorway of light in a bright blue sky with luminous clouds",
    },
    about: {
      eyebrow: "About me",
      titleA: "François Gautier", titleB: "MAKARGA",
      p1: "Spirivie certified practitioner in energy therapy and psychogenealogy. Through Porte de Lumière, I offer a space for listening, exploration and holistic support for those who wish to better understand their life experience, explore their personal and family patterns and move towards greater inner harmony.",
      p2: "My approach embraces the whole person: every support is personalised, within a framework of listening, respect and confidentiality.",
      quote: "Porte de Lumière: a space to explore, understand and move forward.",
      certTitle: "Spirivie certified practitioner",
      certSub: "Energy therapy & psychogenealogy",
      badgeAlt: "Spirivie badge — Certified practitioner",
    },
    dimensions: {
      eyebrow: "The approach",
      titleA: "A", titleB: "whole-person", titleC: "approach",
      items: [
        { title: "Emotional dimension", text: "Listening, putting into words and soothing what you are going through, within a framework of respect and confidentiality." },
        { title: "Energy dimension", text: "Exploring and rebalancing the information and patterns running through your life experience, through the informational approach." },
        { title: "Transgenerational dimension", text: "Following the thread of your family history to understand the patterns that are passed down." },
        { title: "Spiritual dimension", text: "Opening an inner exploration space — including the theme of past lives — according to your goals." },
      ],
    },
    offersTeaser: { eyebrow: "My programs", titleA: "Explore, understand,", titleB: "move forward", cta: "See details" },
    offers: [
      {
        id: "analyse-informationnelle", tagline: "An exploration session", title: "Informational analysis",
        price: "19 000 FCFA", priceAlt: "≈ €29 / $32",
        description: "An exploration session to identify and examine the information and patterns you wish to work on as part of your personal journey.",
        points: ["Identify personal information and patterns", "Examine what you wish to work on", "A personalised exploration session"],
        duration: null,
      },
      {
        id: "harmonisation-informationnelle", tagline: "Individual support", title: "Informational harmonisation",
        price: "39 000 FCFA", priceAlt: "≈ €59 / $65",
        description: "Individual support oriented towards harmonisation and rebalancing according to the informational approach proposed by Porte de Lumière.",
        points: ["Harmonisation and rebalancing", "The Porte de Lumière informational approach", "Dedicated individual support"],
        duration: null,
      },
      {
        id: "programme-transgenerationnel-3-mois", tagline: "3-month program", title: "Transgenerational & past lives holistic support",
        price: "150 000 FCFA", priceAlt: "≈ €229 / $248",
        description: "A personalised three-month support to explore your family history, your transgenerational patterns and, within your spiritual journey, the theme of past lives. The path is built progressively, according to your situation and goals.",
        points: ["Exploring your family history", "Transgenerational patterns", "The theme of past lives (spiritual journey)", "A progressive path according to your goals"],
        duration: "Duration: 3 months",
      },
      {
        id: "programme-transgenerationnel-6-mois", tagline: "6-month program", title: "Transgenerational & past lives holistic support",
        price: "250 000 FCFA", priceAlt: "≈ €381 / $412",
        description: "A personalised six-month support to explore in depth your family history, your transgenerational patterns and the theme of past lives. A complete path, built progressively according to your situation, questions and goals.",
        points: ["In-depth exploration of your family history", "Transgenerational patterns", "The theme of past lives (spiritual journey)", "A progressive path according to your situation, questions and goals"],
        duration: "Duration: 6 months",
      },
    ],
    testimonials: {
      eyebrow: "Testimonials", titleA: "They walked towards", titleB: "more light",
      items: [
        { author: "A. M.", quote: "I finally understood where some of the repeating patterns in my family came from. Thank you for your listening and your gentleness." },
        { author: "S. K.", quote: "Caring and personalised support, within a trusting and confidential framework. I feel lighter, more aligned." },
        { author: "J. D.", quote: "The six-month program allowed me to explore my family history in depth, at my own pace. A true encounter with myself." },
      ],
    },
    sound: {
      eyebrow: "The experience", titleA: "A gentle", titleB: "meditation music",
      text: "During your visit, a gentle meditation music — warm pad tones and soothing singing bowls — can accompany your journey. Simply activate it from the bubble at the bottom left.",
      audioOn: "Gentle meditation on", audioOff: "Gentle meditation", audioTitle: "Gentle meditation music",
    },
    final: {
      eyebrow: "Begin",
      title: "Would you like to ask a question or get in touch about a support program?",
      ctaContact: "Contact form",
    },
    acc: {
      eyebrow: "My programs", titleA: "Paths towards", titleB: "greater harmony",
      paragraph: "Informational analysis, energy harmonisation and transgenerational holistic support — every journey is personalised, within a framework of listening, respect and confidentiality.",
      disclaimerTitle: "Important",
      disclaimer: "The support offered by Porte de Lumière is part of a well-being, personal development and spiritual exploration approach. It does not replace a medical or psychological diagnosis, treatment or follow-up when needed.",
      ctaTitle: "Ready to take the first step?",
      ctaText: "Contact me directly by phone or WhatsApp for any information request or appointment booking.",
      whatsapp: "WhatsApp direct", contact: "Contact", book: "Book a slot",
    },
    contact: {
      eyebrow: "Contact Porte de Lumière", titleA: "Ask a question,", titleB: "get in touch",
      intro: "Would you like to ask a question or get in touch about a support program? Write to me via the form or reach out directly by phone or WhatsApp.",
      bookCta: "Book a slot online",
      form: {
        name: "Your name *", namePh: "Your full name",
        email: "Your email *", emailPh: "you@example.com",
        phone: "Phone / WhatsApp", phonePh: "+237 6 .. .. .. ..",
        service: "Program", servicePh: "Choose (optional)",
        message: "Your message *", messagePh: "Share your question or what you wish to explore…",
        submit: "Send the message", sending: "Sending…",
        note: "Your message goes straight to François by email. For an immediate reply, WhatsApp is best.",
        successTitle: "Message sent",
        successText: "Thank you for your message. François Gautier MAKARGA will reply to you as soon as possible.",
        successReset: "Send another message",
      },
      channels: { email: "Email", whatsapp: "WhatsApp direct", phone: "Phone", facebook: "Facebook", tiktok: "TikTok" },
      quote: "Informational analysis and holistic energy cleansing.",
    },
    booking: {
      eyebrow: "Booking", title: "Book a slot",
      intro: "Choose the program, the date and the time: your request goes straight to François by email, who will confirm the slot with you.",
      serviceLabel: "Program *", servicePh: "Choose a program", unknown: "Not sure yet",
      dateLabel: "Date", slotLabel: "Time slot",
      nameLabel: "Your name *", namePh: "Your full name",
      emailLabel: "Your email *", emailPh: "you@example.com",
      phoneLabel: "Phone / WhatsApp", phonePh: "+237 6 .. .. .. ..",
      submit: "Send booking request", sending: "Sending…",
      note: "No commitment — François will confirm the slot with you by WhatsApp or email, subject to availability.",
      successTitle: "Request sent",
      successText: (service, date, slot) => `${service} — ${date}, time slot ${slot}. François Gautier MAKARGA will confirm this slot with you shortly, subject to availability.`,
      close: "Close", ariaClose: "Close",
      onError: "Please pick a date and a time slot first.",
    },
    toasts: {
      contactOk: "Message sent — you will receive a confirmation email.",
      contactOkNoEmail: "Message received! François will reply to you very soon.",
      contactErr: "Could not send the message. Please try again or reach out on WhatsApp.",
      bookingOk: "Booking request sent — you will receive a confirmation email.",
      bookingOkNoEmail: "Request received! François will confirm the slot with you.",
      bookingErr: "Could not send the booking. Please try again or use WhatsApp.",
    },
  },
};
